import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';
import {ExpandMore} from 'views/icons';

import formatTestResponse from './utils/format_test_response';

const SkillsNewTest = (props) => {
  const {testResponse} = props;

  const [expanded, setExpanded] = React.useState(true);
  const responseContent = formatTestResponse(testResponse);

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: '10px',
        border: '1px solid #E8E4DE',
        backgroundColor: '#FAF8F6',
        boxSizing: 'border-box',
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      <Box
        component='button'
        type='button'
        onClick={() => setExpanded((currentExpanded) => !currentExpanded)}
        sx={{
          width: '100%',
          minHeight: '48px',
          px: '14px',
          py: '12px',
          border: '0',
          backgroundColor: '#FAF8F6',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
          textAlign: 'left',
          appearance: 'none',
          WebkitAppearance: 'none',
        }}
      >
        <Box
          component='span'
          sx={{
            fontSize: '13px',
            fontWeight: 400,
            color: '#9B958F',
            lineHeight: '100%',
          }}
        >
          Preview
        </Box>
        <ExpandMore
          sx={{
            fontSize: '20px',
            color: '#9B958F',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
          }}
        />
      </Box>
      {
        expanded &&
        responseContent &&
        <Box
          sx={{
            px: '14px',
            pb: '14px',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#FAF8F6',
              fontSize: '14px',
              fontWeight: 400,
              color: '#5F5A54',
              lineHeight: '190%',
              whiteSpace: 'pre-line',
            }}
          >
            {responseContent}
          </Box>
        </Box>
      }
    </Box>
  );
};

SkillsNewTest.propTypes = {
  defaultExpanded: PropTypes.bool,
  testResponse: PropTypes.shape({
    result: PropTypes.object,
  }),
};

export default React.memo(SkillsNewTest);
